import React, { useEffect } from 'react';
import Card from '../../Components/Containers/Card';
import { useSession } from '../../Components/Session';
import { PageLoading } from '../../Components/Loading';
import API from '../../Services/API';

const Logout = () => {
    const {logout} = useSession();

    useEffect(() => {
        // Awaited: logout revokes the session and deregisters this device's push
        // token, and reloading over it leaves both in place on a shared device.
        (async () => {
            await logout();
            API.reset();
            window.location.reload();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            <PageLoading />
        </Card>
    </>;
}

export default Logout;
